import { deprecated } from "typesafe-actions";

import { SparepartAssemblyActionTypes } from "./constants";

const { createStandardAction } = deprecated;

/** modal input values are restored or initialized */
export const openSparepartAssemblyModal = createStandardAction(SparepartAssemblyActionTypes.OPEN_SPAREPART_ASSEMBLY_MODAL).map(
  (payload: { id: string; comment: string; earliestDate: Date; requestedDate: Date }) => ({ payload })
);

/**  modal input values are dropped */
export const closeSparepartAssemblyModal = createStandardAction(SparepartAssemblyActionTypes.CLOSE_SPAREPART_ASSEMBLY_MODAL)();

/** modal input values are saved */
export const closeAndSaveSparepartAssemblyModal = createStandardAction(SparepartAssemblyActionTypes.CLOSE_AND_SAVE_SPAREPART_ASSEMBLY_MODAL).map(
  (payload: { id: string; comment: string; earliestDate: Date; requestedDate: Date }) => ({ payload })
);

/** prevent sparepart assembly info for a position from being passed to checkout order submission */
export const disableSparepartAssemblyPositionInfo = createStandardAction(SparepartAssemblyActionTypes.DISABLE_SPAREPART_ASSEMBLY_POSITION_INFO).map(
  (payload: { id: string }) => ({ payload })
);

export const setSparepartAssemblyPositionInfo = createStandardAction(SparepartAssemblyActionTypes.SET_SPAREPART_ASSEMBLY_POSITION_INFO).map(
  (payload: { id: string; comment: string; earliestDate: Date; requestedDate: Date }) => ({ payload })
);

/** Clear single position */
export const clearSparepartAssemblyPositionInfo = createStandardAction(SparepartAssemblyActionTypes.CLEAR_SPAREPART_ASSEMBLY_POSITION_INFO).map(
  (payload: { id: string }) => ({ payload })
);

/** Clean up all sparepart assembly info positions after order submission is successful */
export const clearSparepartAssemblyData = createStandardAction(SparepartAssemblyActionTypes.CLEAR_SPAREPART_ASSEMBLY_DATA)();
